import { BreakpointObserver } from '@angular/cdk/layout'
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { CptSharedDataService } from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { GoogleTagManagerService } from 'angular-google-tag-manager'
import { NGXLogger } from 'ngx-logger'
import {
  KcDataService,
} from '../../../kc-data.service'
import { KcClientData, KcLoginViewData, KcRealmData } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-revolution-login-webwidget',
  templateUrl: './revolution-login-webwidget.component.html',
  styleUrls: ['./revolution-login-webwidget.component.scss']
})
export class RevolutionLoginWebwidgetComponent implements OnInit {
  @ViewChild('loginFormCh', { static: false })
  private readonly formRefCh: ElementRef

  @ViewChild('loginFormDe', { static: false })
  private readonly formRefDe: ElementRef

  emailRegex: string

  public form

  public showPassword = false
  public showPasswordUrl = 'assets/icons/visibility_24px.svg'
  public hidePasswordUrl = 'assets/icons/visibility_off_24px.svg'
  public viewData: KcLoginViewData
  public realmData: KcRealmData
  public loginStarted = false
  public country
  public clientData: KcClientData
  private readonly logo = 'assets/images/ef-logo-blue.svg'
  public logoUrl: string
  public vpn = 'assets/icons/vpn_key_24px.svg'
  public emailImage = 'assets/icons/alternate_email_24px.svg'
  public resetPasswordUrl = ''
  public registrationUrl = ''
  vpnUrl: string
  emailImageUrl: string

  lang = 'de'
  constructor(
    private readonly kcDataService: KcDataService,
    private readonly kcSharedDataService: CptSharedDataService,
    public breakpointObserver: BreakpointObserver,
    private readonly gtmService: GoogleTagManagerService,
    private readonly logger: NGXLogger,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.emailRegex = this.remoteConfigService.get('regEx.emailRegEx.pattern')
    this.country = this.remoteConfigService.get('country.code')
    this.form = new FormGroup({
      email: new FormControl<string | null>(null, [
        Validators.email,
        Validators.pattern(this.emailRegex)
      ]),
      password: new FormControl<string | null>(null, [])
    })
  }

  ngOnInit(): void {
    this.viewData = this.kcDataService.getViewData() as KcLoginViewData
    this.vpnUrl = `${this.kcSharedDataService.getResourcesPath()}/${this.vpn}`
    this.emailImageUrl = `${this.kcSharedDataService.getResourcesPath()}/${
      this.emailImage
    }`

    this.logoUrl = `${this.kcSharedDataService.getResourcesPath()}/${this.logo}`
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()

    this.resetPasswordUrl = this.getUrl(
      this.viewData.loginAction,
      this.viewData.loginResetCredentialsUrl
    )

    this.registrationUrl = this.getUrl(
      this.viewData.loginAction,
      this.viewData.registrationUrl
    )

    this.kcDataService.onKcDataLoaded.subscribe(kcData => {
      const localeData = this.kcDataService.getLocaleData()
      if (localeData) {
        this.lang = localeData.current.substr(0, 2).toLowerCase() ?? 'de'
      }
    })
  }

  public loginCh() {
    this.loginStarted = true
    const formElement = this.formRefCh.nativeElement as HTMLFormElement
    formElement.submit()
  }

  public loginDe() {
    this.loginStarted = true
    const formElement = this.formRefDe.nativeElement as HTMLFormElement
    formElement.submit()
  }

  public getUrl(loginAction: string, urlPart: string) {
    const url = new URL(loginAction)
    return url.origin + urlPart
  }

  public toggleShowPassword() {
    const password = this.form.controls.password.value
    this.showPassword = !this.showPassword
    this.form.controls.password.setValue(password)
  }
}
